import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addComment, seeComments } from '../../actions/commentActions';
import { createReaction } from '../../actions/reactionActions';
import { clearPostInfo, getPostInfo } from '../../actions/userActions';
import ViewStreamView from '../../containers/Stream/ViewStream';
import socketLogic from '../../sockets/sockets';
import { useTokenCallback } from '../../utils/hooks/useTokenCallback';

const ViewStream = ({ match }) => {
  const dispatch = useDispatch()
  const { isLoadingPostInfo, postInfo } = useSelector(state => state.userInfo)
  const { comments, isLoading, isLoadingComment, isLoadingLikePost } = useSelector(state => state.comments)
  const [viewers, setViewers] = useState(0);
  useEffect(() => {
    return () => {
      socketLogic.leaveRoom(match.params.idStream)
      dispatch(clearPostInfo())
      socketLogic.leaveRoom(match.params.idStream)
      socketLogic.removeListener("new-room-client")
      socketLogic.removeListener("new-comment")
    };
  }, []);


  useEffect(() => {
    dispatch(getPostInfo(match.params.idStream))
    dispatch(seeComments(match.params.idStream))


    return () => {

    }
  }, [match.params.idStream])
  useEffect(() => {
    // alert(JSON.stringify(postInfo,null,4))
    if (postInfo[0]) {
      if (postInfo[0]._id) {
        socketLogic.joinRoom(match.params.idStream)
        socketLogic.newComment((data) => {

  
          dispatch(addComment(data))

        })
        socketLogic.newRoomClient((data) => {
          setViewers(data.totalClient)
        })
      }

    }

    return () => {

    }
  }, [postInfo[0]?._id])

  const createReactionBubble = (id, type="comment") => {
    dispatch(createReaction(id, 'RCT01', 0, false, false, type, false))

  }
  const createReactionRecycle = (id, type) => {
    dispatch(createReaction(id, 'RCT02', 0, false, false, type, false))
}

return <ViewStreamView viewers={viewers} isLoadingPostInfo={isLoadingPostInfo} comments={comments} post={postInfo[0]}

  createReactionBubble={createReactionBubble} createReactionRecycle={createReactionRecycle} />
};

export default ViewStream;
